import { AppConst } from 'constants/appConst';

import { useAppState } from 'hooks/useAppState';
import { useAtom } from 'jotai';
import { AcctState } from 'stores/atoms/acctState';
import { formatRateToPercent, getAcquiredListCount } from 'utils/app';

import type { JSX } from 'react';

export default function DashboardLayoutNavbarPlan(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const [acctState] = useAtom(AcctState);
  const { isPublishedCountNoLimit, isMailAddressCountNoLimit, getActivePlan } = useAppState();

  const activePlan = getActivePlan();

  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* プライベート関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   * プラン名を取得します。
   */
  const _getPlanName = (): string => {
    let planName = activePlan?.name ?? '';

    if (acctState.company.plan.isExpired) {
      planName += ' (期限切れ）';
    }
    return planName;
  };

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <div className="progress-bar-container">
      <p className="lead">利用状況</p>

      <ul className="list-unstyled list-progress">
        <li>
          <div className="progress-detail">
            <span>コンテンツ公開数</span>
            <span>
              {acctState.usage.publishedCount} /{' '}
              {isPublishedCountNoLimit() ? '無制限' : (activePlan?.publishContentCountLimit ?? 0)}
            </span>
          </div>
          <div
            className="progress"
            role="progressbar"
            aria-valuenow={75}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            <div
              className="progress-bar"
              style={{
                width: `${
                  isPublishedCountNoLimit()
                    ? 0
                    : formatRateToPercent(
                        acctState.usage.publishedCount,
                        activePlan?.publishContentCountLimit ?? 0
                      )
                }%`,
              }}
            ></div>
          </div>
        </li>

        <li>
          <div className="progress-detail">
            <span>獲得リスト数</span>
            <span>
              {getAcquiredListCount(
                acctState.usage.report.total.mailAddressCount,
                acctState.usage.report.total.lineCount
              )}{' '}
              / {isMailAddressCountNoLimit() ? '無制限' : (activePlan?.mailAddressCountLimit ?? 0)}
            </span>
          </div>
          <div
            className="progress"
            role="progressbar"
            aria-valuenow={75}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            <div
              className="progress-bar"
              style={{
                width: `${
                  isMailAddressCountNoLimit()
                    ? 0
                    : formatRateToPercent(
                        getAcquiredListCount(
                          acctState.usage.report.total.mailAddressCount,
                          acctState.usage.report.total.lineCount
                        ),
                        activePlan?.mailAddressCountLimit ?? 0
                      )
                }%`,
              }}
            ></div>
          </div>
        </li>
        <li>
          <div className="progress-detail">
            <span>現在のプラン</span>
          </div>
          <div className="">
            <p className="mt-2 lead">{_getPlanName()}</p>
          </div>
        </li>
      </ul>

      <a href={AppConst.url.upgrade} className="btn btn-progress d-block mx-auto mt-4">
        アップグレード
      </a>
    </div>
  );
}
